import { getAPIUrl } from '../helpers/App';

export const APIgetRoles = params => (
  window.axios.get(getAPIUrl('/roles'), { params })
    .then(response => (response))
);

export const APIgetRole = roleId => (
  window.axios.get(getAPIUrl(`/roles/${roleId}`))
    .then(response => (response))
);

export const APIcreateRole = role => (
  window.axios.post(getAPIUrl('/roles'), { role })
    .then(response => (response))
);

export const APIupdateRole = role => (
  window.axios.patch(getAPIUrl(`/roles/${role.id}`), { role })
    .then(response => (response))
);

export const APIupdateRoleCapabilities = (roleId, capabilities) => (
  window.axios.patch(getAPIUrl(`/roles/${roleId}/capabilities`), capabilities)
    .then(response => (response))
);

export const APIgetRoleCapabilities = () => (
  window.axios.get(getAPIUrl('/roles/capabilities'))
    .then(response => (response))
);

export const APIdeleteRole = roleId => (
  window.axios.delete(getAPIUrl(`/roles/${roleId}`))
    .then(response => (response))
);
